/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  AggregateResult,
  DetermineEntryTypeRequestRequest,
  DetermineEntryTypeResponse,
  DetermineProblemTypeRequestRequest,
  DetermineProblemTypeResponse,
  PaginatedTicketList,
  PatchedTicketRequest,
  Ticket,
  TicketAttachment,
  TicketAttachmentRequest,
  TicketProblemType,
  TicketRequest,
  TicketsAggregateRetrieveParams,
  TicketsListParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type ticketsListResponse200 = {
  data: PaginatedTicketList
  status: 200
}

export type ticketsListResponseSuccess = (ticketsListResponse200) & {
  headers: Headers;
};
;

export type ticketsListResponse = (ticketsListResponseSuccess)

export const getTicketsListUrl = (params?: TicketsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["cars","entry_type","portfolio","region","service_provider"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/tickets/?${stringifiedParams}` : `/api/v1/tickets/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsList = async (params?: TicketsListParams, options?: RequestInit): Promise<ticketsListResponse> => {

  return customFetch<ticketsListResponse>(getTicketsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type ticketsCreateResponse201 = {
  data: Ticket
  status: 201
}

export type ticketsCreateResponseSuccess = (ticketsCreateResponse201) & {
  headers: Headers;
};
;

export type ticketsCreateResponse = (ticketsCreateResponseSuccess)

export const getTicketsCreateUrl = () => {




  return `/api/v1/tickets/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsCreate = async (ticketRequest: TicketRequest, options?: RequestInit): Promise<ticketsCreateResponse> => {

  return customFetch<ticketsCreateResponse>(getTicketsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ticketRequest)
  }
);}


export type ticketsRetrieveResponse200 = {
  data: Ticket
  status: 200
}

export type ticketsRetrieveResponseSuccess = (ticketsRetrieveResponse200) & {
  headers: Headers;
};
;

export type ticketsRetrieveResponse = (ticketsRetrieveResponseSuccess)

export const getTicketsRetrieveUrl = (id: string,) => {




  return `/api/v1/tickets/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsRetrieve = async (id: string, options?: RequestInit): Promise<ticketsRetrieveResponse> => {

  return customFetch<ticketsRetrieveResponse>(getTicketsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type ticketsUpdateResponse200 = {
  data: Ticket
  status: 200
}

export type ticketsUpdateResponseSuccess = (ticketsUpdateResponse200) & {
  headers: Headers;
};
;

export type ticketsUpdateResponse = (ticketsUpdateResponseSuccess)

export const getTicketsUpdateUrl = (id: string,) => {




  return `/api/v1/tickets/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsUpdate = async (id: string,
    ticketRequest: TicketRequest, options?: RequestInit): Promise<ticketsUpdateResponse> => {

  return customFetch<ticketsUpdateResponse>(getTicketsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ticketRequest)
  }
);}


export type ticketsPartialUpdateResponse200 = {
  data: Ticket
  status: 200
}

export type ticketsPartialUpdateResponseSuccess = (ticketsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type ticketsPartialUpdateResponse = (ticketsPartialUpdateResponseSuccess)

export const getTicketsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/tickets/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsPartialUpdate = async (id: string,
    patchedTicketRequest?: PatchedTicketRequest, options?: RequestInit): Promise<ticketsPartialUpdateResponse> => {

  return customFetch<ticketsPartialUpdateResponse>(getTicketsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedTicketRequest)
  }
);}


export type ticketsDestroyResponse204 = {
  data: void
  status: 204
}

export type ticketsDestroyResponseSuccess = (ticketsDestroyResponse204) & {
  headers: Headers;
};
;

export type ticketsDestroyResponse = (ticketsDestroyResponseSuccess)

export const getTicketsDestroyUrl = (id: string,) => {




  return `/api/v1/tickets/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsDestroy = async (id: string, options?: RequestInit): Promise<ticketsDestroyResponse> => {

  return customFetch<ticketsDestroyResponse>(getTicketsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type ticketsAttachmentsListResponse200 = {
  data: TicketAttachment[]
  status: 200
}

export type ticketsAttachmentsListResponseSuccess = (ticketsAttachmentsListResponse200) & {
  headers: Headers;
};
;

export type ticketsAttachmentsListResponse = (ticketsAttachmentsListResponseSuccess)

export const getTicketsAttachmentsListUrl = (ticketPk: string,) => {




  return `/api/v1/tickets/${ticketPk}/attachments/`
}

export const ticketsAttachmentsList = async (ticketPk: string, options?: RequestInit): Promise<ticketsAttachmentsListResponse> => {

  return customFetch<ticketsAttachmentsListResponse>(getTicketsAttachmentsListUrl(ticketPk),
  {
    ...options,
    method: 'GET'


  }
);}


export type ticketsAttachmentsCreateResponse201 = {
  data: TicketAttachment
  status: 201
}

export type ticketsAttachmentsCreateResponseSuccess = (ticketsAttachmentsCreateResponse201) & {
  headers: Headers;
};
;

export type ticketsAttachmentsCreateResponse = (ticketsAttachmentsCreateResponseSuccess)

export const getTicketsAttachmentsCreateUrl = (ticketPk: string,) => {




  return `/api/v1/tickets/${ticketPk}/attachments/`
}

export const ticketsAttachmentsCreate = async (ticketPk: string,
    ticketAttachmentRequest: TicketAttachmentRequest, options?: RequestInit): Promise<ticketsAttachmentsCreateResponse> => {

  return customFetch<ticketsAttachmentsCreateResponse>(getTicketsAttachmentsCreateUrl(ticketPk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ticketAttachmentRequest)
  }
);}


export type ticketsAttachmentsRetrieveResponse200 = {
  data: TicketAttachment
  status: 200
}

export type ticketsAttachmentsRetrieveResponseSuccess = (ticketsAttachmentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type ticketsAttachmentsRetrieveResponse = (ticketsAttachmentsRetrieveResponseSuccess)

export const getTicketsAttachmentsRetrieveUrl = (ticketPk: string,
    id: string,) => {




  return `/api/v1/tickets/${ticketPk}/attachments/${id}/`
}

export const ticketsAttachmentsRetrieve = async (ticketPk: string,
    id: string, options?: RequestInit): Promise<ticketsAttachmentsRetrieveResponse> => {

  return customFetch<ticketsAttachmentsRetrieveResponse>(getTicketsAttachmentsRetrieveUrl(ticketPk,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type ticketsAttachmentsDestroyResponse204 = {
  data: void
  status: 204
}

export type ticketsAttachmentsDestroyResponseSuccess = (ticketsAttachmentsDestroyResponse204) & {
  headers: Headers;
};
;

export type ticketsAttachmentsDestroyResponse = (ticketsAttachmentsDestroyResponseSuccess)

export const getTicketsAttachmentsDestroyUrl = (ticketPk: string,
    id: string,) => {




  return `/api/v1/tickets/${ticketPk}/attachments/${id}/`
}

export const ticketsAttachmentsDestroy = async (ticketPk: string,
    id: string, options?: RequestInit): Promise<ticketsAttachmentsDestroyResponse> => {

  return customFetch<ticketsAttachmentsDestroyResponse>(getTicketsAttachmentsDestroyUrl(ticketPk,id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type ticketsAggregateRetrieveResponse200 = {
  data: AggregateResult
  status: 200
}

export type ticketsAggregateRetrieveResponseSuccess = (ticketsAggregateRetrieveResponse200) & {
  headers: Headers;
};
;

export type ticketsAggregateRetrieveResponse = (ticketsAggregateRetrieveResponseSuccess)

export const getTicketsAggregateRetrieveUrl = (params: TicketsAggregateRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/tickets/aggregate/?${stringifiedParams}` : `/api/v1/tickets/aggregate/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsAggregateRetrieve = async (params: TicketsAggregateRetrieveParams, options?: RequestInit): Promise<ticketsAggregateRetrieveResponse> => {

  return customFetch<ticketsAggregateRetrieveResponse>(getTicketsAggregateRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type ticketsDetermineEntryTypeCreateResponse200 = {
  data: DetermineEntryTypeResponse
  status: 200
}

export type ticketsDetermineEntryTypeCreateResponseSuccess = (ticketsDetermineEntryTypeCreateResponse200) & {
  headers: Headers;
};
;

export type ticketsDetermineEntryTypeCreateResponse = (ticketsDetermineEntryTypeCreateResponseSuccess)

export const getTicketsDetermineEntryTypeCreateUrl = () => {




  return `/api/v1/tickets/determine-entry-type/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsDetermineEntryTypeCreate = async (determineEntryTypeRequestRequest: DetermineEntryTypeRequestRequest, options?: RequestInit): Promise<ticketsDetermineEntryTypeCreateResponse> => {

  return customFetch<ticketsDetermineEntryTypeCreateResponse>(getTicketsDetermineEntryTypeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(determineEntryTypeRequestRequest)
  }
);}


export type ticketsDetermineProblemTypeCreateResponse200 = {
  data: DetermineProblemTypeResponse
  status: 200
}

export type ticketsDetermineProblemTypeCreateResponseSuccess = (ticketsDetermineProblemTypeCreateResponse200) & {
  headers: Headers;
};
;

export type ticketsDetermineProblemTypeCreateResponse = (ticketsDetermineProblemTypeCreateResponseSuccess)

export const getTicketsDetermineProblemTypeCreateUrl = () => {




  return `/api/v1/tickets/determine-problem-type/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const ticketsDetermineProblemTypeCreate = async (determineProblemTypeRequestRequest: DetermineProblemTypeRequestRequest, options?: RequestInit): Promise<ticketsDetermineProblemTypeCreateResponse> => {

  return customFetch<ticketsDetermineProblemTypeCreateResponse>(getTicketsDetermineProblemTypeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(determineProblemTypeRequestRequest)
  }
);}


export type ticketsProblemTypesListResponse200 = {
  data: TicketProblemType[]
  status: 200
}

export type ticketsProblemTypesListResponseSuccess = (ticketsProblemTypesListResponse200) & {
  headers: Headers;
};
;

export type ticketsProblemTypesListResponse = (ticketsProblemTypesListResponseSuccess)

export const getTicketsProblemTypesListUrl = () => {




  return `/api/v1/tickets/problem-types/`
}

/**
 * List the selectable ticket problem types (the dropdown options the
 * ticket form populates). Replaces reading the choices off an OPTIONS
 * request, which the generated SDK couldn't represent (AMP-502).
 */
export const ticketsProblemTypesList = async ( options?: RequestInit): Promise<ticketsProblemTypesListResponse> => {

  return customFetch<ticketsProblemTypesListResponse>(getTicketsProblemTypesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


